<template>
  <div id="box" class="chat-box">
    <div class="vender-machine not-copy">
      <div class="control has-addons input-wrapper" style="padding: 10px; padding-bottom: 0px;" v-if="topMenu">
        <span class="exit-search" v-if="showSearch" @click="exitSearch"><i class="exit-search -icon mdi mdi-chevron-left"></i></span>
        <input class="input bot-input" type="search" name="search" placeholder="🔍ロボ検索" v-model="keyword" @keyup.enter="search">
      </div>
      <div class="bot-box" :class="{ '-active': isCategoryMenuActive, '-unactive': !isCategoryMenuActive }">
        <div class="icon-box" v-if="showSearch">
          <div v-for="(b, k) in searchHit" :key="k" v-if="widgetData.isAuto > 0 && isBotList && k < (pageIndexBots + 1) * 5" @click="openChatBot(b, k, widgetData.todayIsHoliday)">
            <div class="icon-box">
              <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
              <div class="workday-tooltip">
                <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                <div class="bg-filter-box">
                  <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                </div>
                <!-- <div style="width: calc(100% - 100px);"> -->
                  <p class="name">{{b.display_name}}</p>
                  <!-- <p class="sub-message">{{ramdomMessage()}}</p> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="not-found-msg" v-if="notFound !== ''">{{notFound}}</div>
        </div>
        <div class="icon-box" v-if="tabAll && !showSearch">
          <div v-for="(b, k) in all" :key="k" v-if="all.length > 0 && isBotList && k < (pageIndexBots + 1) * 5" @click="openChatBot(b, k, widgetData.todayIsHoliday)">
            <div class="icon-box-robo">
              <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
              <div class="workday-tooltip">
                <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                <div class="bg-filter-box">
                  <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                  <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                </div>
                <!-- <div style="width: calc(100% - 100px);"> -->
                  <p class="name">{{b.display_name}}</p>
                  <!-- <p class="sub-message">{{ramdomMessage()}}</p> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
          <button class="button" @click="pageIndexBots++" v-if="all.length >= (pageIndexBots + 1) * 5">更に読み込む</button>
        </div>
        <div class="icon-box" v-if="tab0 && !showSearch">
          <div v-for="(b, k) in procedure" :key="k" v-if="procedure.length > 0 && isBotList && k < (pageIndexBots + 1) * 5" @click="openChatBot(b, k, widgetData.todayIsHoliday)">
            <div v-for="(parameter, p) in b.parameter" :key="p">
              <div v-for ="(tabNum, t) in parameter" :key="t">
                <div v-if ="tabNum.idx == 0">
                  <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
                  <div class="workday-tooltip">
                    <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                    <div class="bg-filter-box">
                      <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                      <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                    </div>
                    <!-- <div style="width: calc(100% - 100px);"> -->
                      <p class="name">{{b.tab0Click}}</p>
                      <!-- <p class="sub-message">{{ramdomMessage()}}</p> -->
                    <!-- </div> -->
                  </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div class="icon-box" v-if="tab1 && !showSearch">
          <div v-for="(b, k) in consultation" :key="k" v-if="consultation.length > 0 && isBotList && k < (pageIndexBots + 1) * 5" @click="openChatBot(b, k, widgetData.todayIsHoliday)">
            <div v-for="(parameter, p) in b.parameter" :key="p">
              <div v-for ="(tabNum, t) in parameter" :key="t">
                <div v-if ="tabNum.idx == 1">
                  <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
                  <div class="workday-tooltip">
                    <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                    <div class="bg-filter-box">
                      <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                      <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                    </div>
                    <!-- <div style="width: calc(100% - 100px);"> -->
                      <p class="name">{{b.tab0Click}}</p>
                      <!-- <p class="sub-message">{{ramdomMessage()}}</p> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="icon-box" v-if="tab2 && !showSearch">
          <div v-for="(b, k) in info" :key="k" v-if="info.length > 0 && isBotList && k < (pageIndexBots + 1) * 5" @click="openChatBot(b, k, widgetData.todayIsHoliday)">
            <div v-for="(parameter, p) in b.parameter" :key="p">
              <div v-for ="(tabNum, t) in parameter" :key="t">
                <div v-if ="tabNum.idx == 2">
                  <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
                  <div class="workday-tooltip">
                    <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                    <div class="bg-filter-box">
                      <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data!=''">
                      <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-if="b.icon_data==''">
                    </div>
                    <!-- <div style="width: calc(100% - 100px);"> -->
                      <p class="name">{{b.tab0Click}}</p>
                      <!-- <p class="sub-message">{{ramdomMessage()}}</p> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="icon-box" v-if="tab3 && !showSearch">
          <div v-for="(b, k) in news" :key="k" v-if="news.length > 0 && isBotList && k < (pageIndexBots + 1) * 5" @click="openChatBot(b, k, widgetData.todayIsHoliday)">
            <div v-for="(parameter, p) in b.parameter" :key="p">
              <div v-for ="(tabNum, t) in parameter" :key="t">
                <div v-if ="tabNum.idx == 3">
                  <span class="tag tag-num" v-if="isStartBot(b)&&selectTagNewMsg>0">{{selectTagNewMsg}}</span>
                  <div class="workday-tooltip">
                    <div class="tooltip-workday-message" v-if="isOffDuty(b, widgetData.todayIsHoliday)">{{getWorkDayMessage(b)}}<br>{{getWorkTimeMessage(b)}}</div>
                    <div class="bg-filter-box">
                      <img class="img-icon" :style="makeImgIcon()" :src="b.icon_data" v-if="b.icon_data">
                      <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-else>
                    </div>
                    <!-- <div style="width: calc(100% - 100px);"> -->
                      <p class="name">{{b.tab0Click}}</p>
                      <!-- <p class="sub-message">{{ramdomMessage()}}</p> -->
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="icon-box" v-for="(u, k) in widgetData.users" :key="k" @click="openDirectTalk(u)" v-if="isStaffList">
          <div class="bg-filter-box">
            <img class="img-icon" :style="makeImgIcon()" :src="u.icon" v-if="u.icon!=''">
            <img class="img-icon" :style="makeImgIcon()" src="@/assets/template/robot.png" v-if="u.icon==''">
          </div>
          <div style="width: calc(100% - 100px);">
            <p class="name">{{u.username}}</p>
            <p class="sub-message">{{u.message}}</p>
          </div>
        </div>
        <div class="icon-box" style="flex-direction: column;" :key="k" v-if="isAdvertise">
          <p style="padding: 10px;"><b>Powered by</b></p>
          <a href="https://hr-monster.io" target="_blank" style="width: calc(100% - 10px); height: 300px; border: solid thin #ccc; margin-left: 10px; background: white; cursor: pointer;">
            <div style="height: 120px; width: 100%"><img style="height: 100%; object-fit: cover;" src="@/assets/HRMONSTER_LOGO.png"/></div>
            <p style="height: 150px; width: 100%; text-align: left; font-size: 13px; padding: 5px; color: black;">
              HRモンスター | 自動スカウトする採用支援ツール<br/>
              <span style="color: #888;">
                HRモンスターはこれまでの採用サービスとは違った新しい採用プラットフォームです。 今まで求人媒体では掴めなかった潜在層へスカウトすることができます。 ホームページに1行追加するだけで、公式ページが採用の場へと変わります。
              </span>
            </p>
            <p style="height: 30px; width: 100%; text-align: right; font-size: 12px; padding: 5px;">
              <a href="https://hr-monster.io" target="_blank">hr-monster.io</a>
            </p>
          </a>
        </div>   
      </div>
      <!-- ロボタグ修正に伴いコメントアウト -->
      <!-- <ul class="tabs" v-if="topMenu && !showSearch && color.categorymenuType == 0">
        <li class="tabs_item" @click="tabAllClick" :class="{active_tab:tabAll}">
          <p class="tabs_icon"><i class="mdi mdi-apps"></i></p>
          <p class="tabs_name" style="margin-bottom:1em;">一覧</p>
        </li>
        <li class="tabs_item" @click="tab0Click" :class="{active_tab:tab0}">
          <p class="tabs_icon"><i class="mdi mdi-newspaper"></i></p>
          <p>ニュース・<br>トピック</p>
        </li>
        <li class="tabs_item" @click="tab1Click" :class="{active_tab:tab1}">
          <p class="tabs_icon"><i class="mdi mdi-comment-processing-outline"></i></p>
          <p>相談<br>（匿名可）</p>
        </li>
        <li class="tabs_item" @click="tab2Click" :class="{active_tab:tab2}">
          <p class="tabs_icon"><i class="mdi mdi-pencil-box-outline"></i></p>
          <p>手続き</p>
        </li> -->
        <!-- <li class="tabs_item" @click="tab3Click" :class="{active_tab:tab3}">
          <p class="tabs_icon"><i class="mdi mdi-information-outline"></i></p>
          <p class="tabs_line1">情報案内</p>
        </li> -->
      <!-- </ul> -->
      <!-- <div style="padding: 10px 0; width: 100%; background: #333; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px; display: flex; justify-content: center; align-items: center;">
        <button style="width: 33%; color: white; font-size: 35px; background: #333; border: none;" @click="isBotList=true;isStaffList=false;isAdvertise=false;topMenu=true"><span class="mdi mdi-robot"></span></button>
        <button style="width: 33%; color: white; font-size: 35px; background: #333; border: none;" @click="isBotList=false;isStaffList=true;isAdvertise=false;topMenu=false"><span class="mdi mdi-account-group"></span></button>
        <button style="width: 33%; color: white; font-size: 35px; background: #333; border: none;" @click="isBotList=false;isStaffList=false;isAdvertise=true;topMenu=false"><span class="mdi mdi-file-document-box-multiple-outline"></span></button>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import resetLocalStorageSeeker from '@/functions/resetLocalStorageSeeker'
import {
  isOffDuty,
  getWorkDayMessage,
  getWorkTimeMessage,
} from '@/functions/robo/roboOffDuty'
export default {
  name: 'SelectConvVenderMobile',
  data () {
    return {
      activeTab: 0,
      isBotList: true,
      isStaffList: false,
      isAdvertise: false,
      url: process.env.WDT_ENDPOINT,
      pos: null,
      cardWidth: 0,
      currentWidth: null,
      kMobile: 33,
      kPC: 3.72,
      kx: 2,
      mobileWidth: 320,
      number: 0,
      cardIdx: 0,
      count: 0,
      iNum: 0,
      animInFlg: [],
      animOutFlg: [],
      animInPrevFlg: [],
      animOutPrevFlg: [],
      bot: null,
      botIndex: -1,
      pageIndexBots: 0,
      pageIndexUsers: 0,
      isPaging: false,
      rFlg: 0,
      rMsg: 0,
      lastMessage: '名の\n訪問者と会話しております。',
      secondMessage: '会社情報の閲覧や\nメッセージのやりとりができます。',
      procedure: [],
      consultation: [],
      info: [],
      news: [],
      all: [],
      tabAll: true,
      tab0: false,
      tab1: false,
      tab2: false,
      tab3: false,
      topMenu: true,
      keyword: '',
      searchHit: [],
      showSearch: false,
      notFound: '',
      isCategoryMenuActive: false
    }
  },
  computed: {
    ...mapState('auth', ['color']),
    ...mapState('directtalk', ['widgetData', 'color', 'data', 'own', 'targetID', 'selectTagNewMsg', 'alreadyCount', 'messagePages', 'seeker']),
    ...mapState('chatbot', ['scenarioTable', 'isSwitch', 'minipk'])
  },
  mounted () {
    this.activeCheck()
    this.isCategories()
  },
  methods: {
    activeCheck () {
      if (this.color.categorymenuType == 1) {
        this.isCategoryMenuActive == false
      } else {
        this.isCategoryMenuActive == true
      }
    },
    isCategories () {
      console.debug('*** Start *** isCategories')
      for ( var v of this.widgetData.bots){
        var category = v.parameter.category.map ( (e) => {
          if (e.idx == 0) {
            this.procedure.push(v)
          } else if (e.idx == 1) {
            this.consultation.push(v)
          } else if (e.idx == 2) {
            this.info.push(v)
          } else if (e.idx == 3) {
            this.news.push(v)
          }
          this.all.push(v)
        })
      }
      this.all = [...new Set(this.all)]
      console.debug('*** End *** isCategories')
    },
    getRandomInt (max) {
      return Math.floor(Math.random() * Math.floor(max))
    },
    ramdomMessage () {
      console.debug('*** Start *** ramdomMessage')
      this.rMsg = this.getRandomInt(6)
      switch (this.rMsg) {
        case 0:
          return 'こちらから会話できます！'
          break
        case 1:
          return 'こんにちは！'
          break
        case 2:
          return 'ようこそ！'
          break
        case 3:
          return 'お気軽にどうぞ！'
          break
        case 4:
          return 'ロボです！'
          break
        case 5:
          return 'お話ししませんか？'
          break
      }
    },
    nextView (isBot) {
      console.debug('*** Start *** nextView')
      console.debug('isBot: ' + JSON.stringify(isBot))
      var w = document.body.clientWidth
      this.isPaging = true
      if (isBot && w > 500) {
        console.info('isBot && w > 500')
        if (this.widgetData.bots.length <= (this.pageIndexBots + 5)) this.pageIndexBots = 0
        else this.pageIndexBots += 5
      } else if (!isBot && w > 500) {
        console.info('!isBot && w > 500')
        if (this.widgetData.users.length <= (this.pageIndexUsers + 2)) this.pageIndexUsers = 0
        else this.pageIndexUsers += 2
      } else if (isBot && w <= 500) {
        console.info('isBot && w <= 500')
        if (this.widgetData.bots.length <= (this.pageIndexBots + 5)) this.pageIndexBots = 0
        else this.pageIndexBots += 5
      } else if (!isBot && w <= 500) {
        console.info('!isBot && w <= 500')
        if (this.widgetData.users.length <= (this.pageIndexUsers + 3)) this.pageIndexUsers = 0
        else this.pageIndexUsers += 3
      }
      setTimeout(() => {this.isPaging = false}, 100)
      console.debug('*** End *** nextView')
    },
    getSizeBot () {
      console.debug('*** Start *** getSizeBot')
      // var w = document.body.clientWidth
      var w = screen.width
      if (w > 500) return 5
      else  return 5
    },
    getSizeHuman () {
      console.debug('*** Start *** getSizeHuman')
      // var w = document.body.clientWidth
      var w = screen.width
      if (w > 500) return 2
      else return 3
    },
    isStartBot (b) {
      console.debug('*** Start *** isStartBot')
      console.debug('b: ' + JSON.stringify(b))
      var urlAryS = b.start_url.split('|')
      for (var j in urlAryS) {
        if (urlAryS[j] == this.data.url) return true
      }
      return false
    },
    hoverClass (event, idx, flg) {
      console.debug('*** Start *** hoverClass')
      console.debug('event: ' + JSON.stringify(event))
      console.debug('idx: ' + JSON.stringify(idx))
      console.debug('flg: ' + JSON.stringify(flg))
      var ch = document.querySelector('a.hover-chat-' + idx)
      var sk = document.querySelector('a.hover-skill-' + idx)
      if (!flg) {
        console.info('flg is false')
        ch.style.opacity = 0
        sk.style.opacity = 0
        ch.style.transform = 'scale(0, 1)'
        sk.style.transform = 'scale(0, 1)'
      } else {
        console.info('flg is true')
        ch.style.opacity = 1
        sk.style.opacity = 1
        ch.style.transform = 'scale(1, 1)'
        sk.style.transform = 'scale(1, 1)'
      }
      console.log('idx: ' + idx + ', flg: ' + flg)
      console.debug('*** End *** hoverClass')
    },
    makeImgIcon () {
      console.debug('*** Start *** makeImgIcon')
      return {
        'border-color': this.color.iconBg
      }
    },
    makeColor () {
      console.debug('*** Start *** makeColor')
      return {
        'background': this.color.iconBg,
        'color': this.color.iconFr,
        'border-color': this.color.iconBg
      }
    },
    makeColorR () {
      console.debug('*** Start *** makeColorR')
      return {
        'background': this.color.iconFr,
        'color': this.color.iconBg,
        'border-color': this.color.iconBg
      }
    },
    openDirectTalk (u) {
      this.$store.dispatch('directtalk/setDT', {name: u.username, icon: u.icon, id: u.userID, model: 'user'})
      this.$store.dispatch('directtalk/createSeekerATHistory', {target: 'none', action: 'click_room', url: this.data.url, element: 'button'})
      this.$emit('changeModalDialog')
    },
    openChatBot (b, idx, todayIsHoliday) {
      if (isOffDuty(b, todayIsHoliday)) {
        // 勤務時間外
        return
      }
      let targetMini = this.minipk || null
      let selectMini = b.pk || null
      if (this.targetID !== b.bot_id || targetMini !== selectMini) {
        this.$emit('openCB', b.header_title, b.bot_header_type)
        this.botIndex = idx
        this.bot = b
        this.$store.dispatch('directtalk/setDT', {name: b.display_name, icon: b.icon_data, id: b.bot_id, model: 'bot'})
        this.$store.dispatch('chatbot/setMiniPK', selectMini)
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: b.display_name, action: 'click_room', url: this.data.url, element: 'button'})
        this.createSKTagHistory('click_room', b.tag)
        let id = b.pk || b.bot_id
        let lv = localStorage.getItem('scenariolv_' + id)
        if (lv) {
          lv = JSON.parse(lv)
          lv.scenario_name = b.scenario_name
          if (lv.node == '') {
            lv = null
            localStorage.removeItem('scenariolv_' + id)
          }
        }
        if (!lv) {
          resetLocalStorageSeeker(this.seeker.id)
          this.$store.dispatch('chatbot/getScenarioOne', { companyid: this.data.ckey, scenarioName: b.scenario_name, node: 'INITIALIZE', rate: this.color.thinking_rate, minipk: b.pk ? b.pk : null})
        }
        this.$store.commit('chatbot/SET_LAST_VIEW', lv)
      } else {
        this.$store.dispatch('directtalk/setDT', {name: b.display_name, icon: b.icon_data, id: b.bot_id, model: 'bot'})
        this.$store.dispatch('chatbot/setMiniPK', selectMini)
        this.$store.dispatch('directtalk/createSeekerATHistory', {target: b.display_name, action: 'click_room', url: this.data.url, element: 'button'})
        this.createSKTagHistory('click_room', b.tag)
      }
      this.$emit('changeModalDialog')
    },
    isOffDuty (robo, todayIsHoliday) {
      // ロボ非番判定
      return isOffDuty(robo, todayIsHoliday)
    },
    getWorkDayMessage (robo) {
      // 稼働日メッセージ取得
      return getWorkDayMessage(robo)
    },
    getWorkTimeMessage (robo) {
      // 稼働時間メッセージ取得
      return getWorkTimeMessage(robo)
    },
    tabAllClick () {
      this.tab0 = false
      this.tab1 = false
      this.tab2 = false
      this.tab3 = false
      this.tabAll = true
      this.$emit('tab-name', 'ロボ一覧')
      console.debug('*** End *** tabAllClick')
    },
    tab0Click () {
      console.debug('*** Start *** tab0Click')
      this.tabAll = false
      this.tab1 = false
      this.tab2 = false
      this.tab3 = false
      this.tab0 = true
      this.$emit('tab-name', 'ニュース・トピック')
      console.debug('*** End *** tab0Click')
    },
    tab1Click () {
      console.debug('*** Start *** tab1Click')
      this.tabAll = false
      this.tab0 = false
      this.tab2 = false
      this.tab3 = false
      this.tab1 = true
      this.$emit('tab-name', '相談（匿名可）')
      console.debug('*** End *** tab1Click')
    },
    tab2Click () {
      console.debug('*** Start *** tab2Click')
      this.tabAll = false
      this.tab0 = false
      this.tab1 = false
      this.tab3 = false
      this.tab2 = true
      this.$emit('tab-name', '手続き')
      console.debug('*** End *** tab2Click')
    },
    tab3Click () {
      console.debug('*** Start *** tab3Click')
      this.tabAll = false
      this.tab0 = false
      this.tab1 = false
      this.tab2 = false
      this.tab3 = true
      this.$emit('tab-name', '情報案内')
      console.debug('*** End *** tab3Click')
    },
    search () {
      this.notFound = ''
      if (this.keyword !== '') {
        this.searchHit = []
        for (var bots of this.widgetData.bots) {
          if (bots.display_name.indexOf(this.keyword) > -1) {
            this.searchHit.push(bots)
          }
        }
        if (this.searchHit.length === 0) {
          console.debug('search result none')
          this.notFound = 'マッチするロボが見つかりませんでした。'
        }
        this.showSearch = true
        this.activeTab = 4
        this.$emit('search')
      } 
    },
    exitSearch () {
      console.debug('*** Start *** exitSearch')
      this.showSearch = false
      this.keyword = ''
      this.$emit('exit-search')
      console.debug('*** End *** exitSearch')
    },
    createSKTagHistory (action_name, tag) {
      const tempSeekerTagHistory = {
        seeker: this.seeker.pk,
        action_name: 'click_room',
        url: this.data.url,
        tag: tag
      }
      this.$store.dispatch('directtalk/createSeekerTagHistory', tempSeekerTagHistory)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.chat-box {
  position: relative !important;
  height: 100%;
  width:  100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.vender-machine {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
.main-message {
  font-size: 20px;
  font-weight: 700;
  color: #AE2B98;
}
.vending-header {
  padding: 10px;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-wrapper {
  width: 100%;
  display: block;
  position: sticky;
  top: 0;
  z-index: 9999;
}
.bot-input {
  margin-bottom: 16px;
}
.exit-search {
  text-align: left;
  & .-icon {
    font-size: 20px;
  }
}
.search-result {
  font-size: 18px;
  font-weight: bold;
}
.not-found-msg {
  margin-top: 16px;
}
.bot-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 15px;
  padding-top: 0;
  position: relative;
  overflow-y: scroll;
  &.-active {
    height: calc(100% - 136px);
  }
  &.-unactive {
    height: calc(100% - 78px);
  }
}
.bot-box::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.name {
  text-align: left;
  margin-left: 15px;
  font-weight: 600;
}
.sub-message {
  text-align: left;
  margin-left: 15px;
  color: #888;
}
.next-arrow {
  position: absolute;
  cursor: pointer;
  top: 40%;
  right: -30px;
  width: 30px;
  height: 50px;
  border: solid 2px #777;
  border-radius: 5px;
  color: #777;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.next-arrow-human {
  position: absolute;
  cursor: pointer;
  top: 40%;
  right: 235px;
  width: 30px;
  height: 50px;
  border: solid 2px #777;
  border-radius: 5px;
  color: #777;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.human-box {
  height: 30%;
  width: 90%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-top: 15px;
  position: relative;
}
.tag-num {
  display: none;
  position: absolute;
  font-size: 16.5px;
  right: -5px;
  top: -5px;
  background: #ff3355;
  color: white;
  width:  32px;
  height: 32px;
  border-radius: 50%;
  z-index: 100;
}
.footer-box {
  height: 30px;
  width: 100%;
}
.icon-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  position: relative;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.icon-box-robo {
  width: 100%;
  margin-top: 24px;
  margin-bottom: 10px;
}
.icon-box:hover {
  transform: scale(1.05);
}
.icon-human-box {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  margin: 5px;
}
.icon-human-box:hover {
  transform: scale(1.05);
}
.img-icon {
  display: block;
  width:  100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.bg-filter-box {
  display: inline-block;
  position: relative;
  cursor: pointer;
  height: 80px;
  width:  80px;
  // overflow: hidden;
  border-radius: 15px;
}
.tabs {
  font-size: bold;
  padding: 4px 0;
  width: 100%;
  background: #333;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tabs_item {
  width: 33%;
  color: white;
  font-size: 14px;
  font-weight: bold;
  background: #333;
  border: none;
  font-size: 10px;
}
.tabs_icon {
  font-size: 24px;
}
.tabs_line1 {
  padding: 7.5px;
}
.workday-tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-workday-message {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  width         : 200px;
  z-index       : 10;
  text-align: center;
}
.tooltip-workday-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.workday-tooltip:hover .tooltip-workday-message{
  display : inline-block;
  top     : 34px;
  left    : -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/SelectConvVenderMobile.vue